"use strict";
// tslint:disable:jsx-no-lambda 
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var rc_tooltip_1 = require("rc-tooltip");
var React = require("react");
var react_select_1 = require("react-select");
require("./ComboBox.scss");
function ComboBox(props) {
    var labelText = props.labelText, className = props.className, required = props.required, placeholder = props.placeholder, value = props.value, disabled = props.disabled, onChange = props.onChange, labelProps = props.labelProps, errorMessage = props.errorMessage, validationState = props.validationState, size = props.size, multiSelect = props.multiSelect, matchPos = props.matchPos, rest = __rest(props, ["labelText", "className", "required", "placeholder", "value", "disabled", "onChange", "labelProps", "errorMessage", "validationState", "size", "multiSelect", "matchPos"]);
    var labelPropsObj = labelProps ? labelProps : {};
    var sizeClass = size ? size : 'default';
    var validationClass = '';
    if (validationState === 'invalid') {
        validationClass = 'invalid';
    }
    else if (validationState === 'valid') {
        validationClass = 'valid';
    }
    var divClasses = classNames({ 'form-group': true }, className);
    var labelClasses = classNames({ 'required-input-label': props.required }, labelPropsObj.className);
    var selectClasses = classNames(validationClass, sizeClass);
    if (!labelText) {
        divClasses = classNames({ 'form-group': true, 'flex-ComboBox-container': true }, className);
        labelClasses = classNames({ 'required-input-label': props.required, 'flex-ComboBox-label': true }, labelPropsObj.className);
        selectClasses = classNames({ 'flex-ComboBox': true }, validationClass, sizeClass);
    }
    var select;
    if (multiSelect) {
        select = (React.createElement(react_select_1.default, { options: props.options, value: props.value, onChange: props.onChange, disabled: props.disabled, searchable: props.searchable, placeholder: placeholder, clearable: false, className: selectClasses, multi: multiSelect, valueComponent: SelectValue, matchPos: matchPos }));
    }
    else {
        select = (React.createElement(react_select_1.default, { options: props.options, value: props.value, onChange: props.onChange, disabled: props.disabled, searchable: props.searchable, placeholder: placeholder, clearable: false, className: selectClasses, matchPos: matchPos }));
    }
    function wrapSelectWithTooltip(el) {
        if (validationState === 'invalid' && errorMessage) {
            return (React.createElement(rc_tooltip_1.default, { placement: 'bottom', overlay: errorMessage, overlayClassName: 'error-tooltip' }, el));
        }
        else {
            return el;
        }
    }
    var selectComponent = wrapSelectWithTooltip(select);
    return (React.createElement("div", { className: divClasses },
        React.createElement("label", { className: labelClasses }, props.labelText),
        selectComponent));
}
exports.ComboBox = ComboBox;
var SelectValue = (function (_super) {
    __extends(SelectValue, _super);
    function SelectValue() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectValue.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { id: this.props.id, className: 'Select-value' },
            React.createElement("span", { className: 'Select-value-label', role: 'option', "aria-selected": 'true', id: 'react-select-2--value-0' },
                this.props.value.label,
                React.createElement("span", { className: 'Select-value-icon', "aria-hidden": 'true', 
                    // tslint:disable-next-line:jsx-no-multiline-js
                    onMouseDown: function (e) {
                        if (!_this.props.disabled) {
                            if (_this.props.onClick != null) {
                                _this.props.onClick(e);
                            }
                            _this.props.onRemove(_this.props.value);
                        }
                        e.stopPropagation();
                    } }, "\u00D7"))));
    };
    return SelectValue;
}(React.Component));
//# sourceMappingURL=ComboBox.js.map